import axiosInstance from "./axiosInstance";
// export const fetch_billPay_info = async (data) => {
//   try {
//     const response = await axiosInstance.post(`/api/bill/details`,data);
//     return {
//       success: true,
//       data: response?.data?.data,
//       message: response?.data?.message || "successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         " failed. Please try again.",
//       status: error.response?.status || 500,
//     };
//   }
// };



export const fetch_billPay_info = async (data) => {
  try {
    const response = await axiosInstance.post(`/api/bill/details`, data);

    return {
      success: response?.data?.success, // ✅ backend se direct
      data: response?.data,
      message: response?.data?.message,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "Unable to fetch bill. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
// export const fetch_billPay_info = async (data) => {
//   try {
//     const response = await axiosInstance.post(`/api/bill/details`, data);

//     return {
//       success: response?.data?.success, // ✅ backend se direct
//       data: response?.data?.data,
//       message: response?.data?.message,
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         "Unable to fetch bill. Please try again.",
//       status: error.response?.status || 500,
//     };
//   }
// };

export const fetch_bill_operators= async () => {
  try {
    const res = await axiosInstance.get("/api/bill/bill-operators/total");

    return {
      success: res?.data?.success,
      data: res?.data,
      message: res?.data?.message,
    };
  } catch (err) {
    return {
      success: false,
      message: "Failed to load categories",
    };
  }
};


export const fetch_lpg_operators= async () => {
  try {
    const res = await axiosInstance.get("/api/bill/lpg-operators/total");

    return {
      success: res?.data?.success,
      data: res?.data,
      message: res?.data?.message,
    };
  } catch (err) {
    return {
      success: false,
      message: "Failed to load categories",
    };
  }
};

export const fetch_fastag_operators= async () => {
  try {
    const res = await axiosInstance.get("/api/bill/fastag-operators/total");

    return {
      success: res?.data?.success,
      data: res?.data,
      message: res?.data?.message,
    };
  } catch (err) {
    return {
      success: false,
      message: "Failed to load categories",
    };
  }
};

export const submit_billPay_amount = async (data) => {
  try {
    const response = await axiosInstance.post(`/api/bill/pay_amount/billpay`,data);
    return {
      success: response?.data?.success,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const fetch_fastag_info = async (data) => {
  try {
    const response = await axiosInstance.post(`/api/bill/fastag`,data);
    return {
      success:response?.data?.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const submit_fastag_amount = async (data) => {
  try {
    const response = await axiosInstance.post(`/api/bill/pay_amount/fastag`,data);
    return {
      success:response?.data?.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const fetch_lpg_info = async (data) => {
  try {
    const response = await axiosInstance.post(`/api/bill/lpg-data`,data);
    return {
      success:response?.data?.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const submit_lpg_amount = async (data) => {
  try {
    const response = await axiosInstance.post(`/api/bill/pay_amount/lpg-amount`,data);
    return {
      success:response?.data?.success ||  true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};